

/**
 * Scroll detection helpers
 * @type {{isElementInContentView: ScrollManager.isElementInContentView, isElementInViewport: ScrollManager.isElementInViewport, onVisibilityChange: ScrollManager.onVisibilityChange}}
 */
let ScrollManager = {
  /**
   * Gets scrollbar width, the 17px windows one...
   * @returns {number}
   */
  getScrollbarWidth() {
    let outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar";
    document.body.appendChild(outer);
    let widthNoScroll = outer.offsetWidth;
    outer.style.overflow = "scroll";
    let inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    let widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
  },
  /**
   * Detects if element is in the view port of an elements context compared to it's customizable scrolling element
   * @param scrollingel
   * @param elem
   * @returns {boolean}
   */
  isElementWithinContentView: function (scrollingel, elem) {
    let container = $(scrollingel);
    let contHeight = container.height();
    let contTop = container.scrollTop();
    let contBottom = contTop + contHeight;
    if (_.has($(elem).offset(), 'top')) {
      let elememTop = $(elem).offset().top - container.offset().top;
      let elememBottom = elememTop + $(elem).height();
      return (elememTop >= 0 && elememBottom <= contHeight);
    }
  },
  /**
   *
   * Checks if element to detect is out of focus of the scroll bar of the main content view
   * @param elem
   * @returns {boolean}
   */
  isElementInContentView: function (elem) {
    let container = $(".main-content");
    let contHeight = container.height();
    let contTop = container.scrollTop();
    let contBottom = contTop + contHeight;
    if (_.has($(elem).offset(), 'top')) {
      let elememTop = $(elem).offset().top - container.offset().top;
      let elememBottom = elememTop + $(elem).height();
      return (elememTop >= 0 && elememBottom <= contHeight);
    }
  },
  /**
   *
   * @param elem
   * @returns {boolean}
   */
  isElementInViewport: function (elem) {
    if (typeof jQuery === "function" && elem instanceof jQuery) {
      elem = elem[0];
    }
    if (!elem) {
      return;
    }
    var rect = elem.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
  },
  onVisibilityChange: function (elem, callback) {
    var old_visible;
    return function () {
      var visible = this.isElementInViewport(elem);
      if (visible !== old_visible) {
        old_visible = visible;
        if (typeof callback === 'function') {
          callback();
        }
      }
    }
  },
};

export default ScrollManager;



// WEBPACK FOOTER //
// ./src/helpers/ScrollManager/index.js